function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// alerts
var attention = Prompt();

function successAlert(x) {
  notie.alert({
    type: 'success',
    text: x
  });
}

function errorAlert(x) {
  notie.alert({
    type: 'error',
    text: x,
    stay: true
  });
}

function warningAlert(x) {
  notie.alert({
    type: 'warning',
    text: x
  });
}

function modalAlert(x) {
  attention.alert({
    html: x
  });
}

function modalErrorAlert(x) {
  attention.alert({
    html: x,
    icon: 'error'
  });
}

var slideUp = function slideUp(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(function () {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property'); //alert("!");
  }, duration);
};

var slideDown = function slideDown(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  target.style.removeProperty('display');
  var display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  var height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(function () {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

var slideToggle = function slideToggle(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

var removeClassFromItems = function removeClassFromItems(match, className) {
  var els = document.getElementsByClassName(match);

  if (els.length > 0) {
    for (i = 0; i < els.length; i++) {
      els[i].classList.remove(className);
    }
  }
};

var addClassToItems = function addClassToItems(match, className) {
  var els = document.getElementsByClassName(match);

  if (els.length > 0) {
    for (i = 0; i < els.length; i++) {
      els[i].classList.add(className);
    }
  }
};

function Prompt() {
  function toast(c) {
    var _c$msg = c.msg,
        msg = _c$msg === void 0 ? "" : _c$msg,
        _c$icon = c.icon,
        icon = _c$icon === void 0 ? "success" : _c$icon;
    var Toast = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      onOpen: function onOpen(toast) {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
    Toast.fire({
      icon: icon,
      title: msg
    });
  }

  function alert(c) {
    var _c$cancelButton = c.cancelButton,
        cancelButton = _c$cancelButton === void 0 ? false : _c$cancelButton,
        _c$html = c.html,
        html = _c$html === void 0 ? "Some warning" : _c$html,
        _c$icon2 = c.icon,
        icon = _c$icon2 === void 0 ? "success" : _c$icon2,
        _c$confirmButtonText = c.confirmButtonText,
        confirmButtonText = _c$confirmButtonText === void 0 ? "OK" : _c$confirmButtonText,
        _c$confirmButton = c.confirmButton,
        confirmButton = _c$confirmButton === void 0 ? true : _c$confirmButton,
        _c$title = c.title,
        title = _c$title === void 0 ? '' : _c$title;

    var _Swal$fire$then = Swal.fire({
      html: html,
      confirmButtonText: confirmButtonText,
      icon: icon,
      showCancelButton: cancelButton,
      showConfirmButton: confirmButton,
      title: title
    }).then(function (result) {
      if (result) {
        if (result.dismiss === Swal.DismissReason.cancel) {} else {}
      }
    }),
        result = _Swal$fire$then.value;
  }

  function confirm(c) {
    var _c$cancelButton2 = c.cancelButton,
        cancelButton = _c$cancelButton2 === void 0 ? true : _c$cancelButton2,
        _c$html2 = c.html,
        html = _c$html2 === void 0 ? "Are you sure?" : _c$html2,
        _c$icon3 = c.icon,
        icon = _c$icon3 === void 0 ? "warning" : _c$icon3,
        _c$confirmButtonText2 = c.confirmButtonText,
        confirmButtonText = _c$confirmButtonText2 === void 0 ? "OK" : _c$confirmButtonText2;

    var _Swal$fire$then2 = Swal.fire({
      html: html,
      confirmButtonText: confirmButtonText,
      icon: icon,
      showCancelButton: cancelButton,
      backdrop: false,
      showCloseButton: false
    }).then(function (result) {
      if (result) {
        if (result.dismiss !== Swal.DismissReason.cancel) {
          if (c.callback !== undefined) {
            c.callback(true);
          }
        } else {
          c.callback(false);
        }
      } else {
        c.callback(false);
      }
    }),
        result = _Swal$fire$then2.value;
  }

  function promptConfirm(c) {
    var _c$cancelButton3 = c.cancelButton,
        cancelButton = _c$cancelButton3 === void 0 ? true : _c$cancelButton3,
        _c$html3 = c.html,
        html = _c$html3 === void 0 ? "Are you sure?" : _c$html3,
        _c$icon4 = c.icon,
        icon = _c$icon4 === void 0 ? "warning" : _c$icon4,
        _c$confirmButtonText3 = c.confirmButtonText,
        confirmButtonText = _c$confirmButtonText3 === void 0 ? "OK" : _c$confirmButtonText3,
        _c$confirmationText = c.confirmationText,
        confirmationText = _c$confirmationText === void 0 ? "Yes" : _c$confirmationText;

    var _Swal$fire$then3 = Swal.fire({
      html: html,
      showConfirmButton: true,
      confirmButtonText: confirmButtonText,
      icon: icon,
      input: 'text',
      showCancelButton: cancelButton,
      backdrop: false,
      showCloseButton: false
    }).then(function (result) {
      if (result) {
        if (result.dismiss !== Swal.DismissReason.cancel) {
          if (result.value.toUpperCase() === confirmationText.toUpperCase()) {
            if (c.callback !== undefined) {
              c.callback(true);
            }
          } else {
            c.callback(false);
          }
        } else {
          c.callback(false);
        }
      }
    }),
        result = _Swal$fire$then3.value;
  }

  function prompt(c) {
    var _c$cancelButton4 = c.cancelButton,
        cancelButton = _c$cancelButton4 === void 0 ? true : _c$cancelButton4,
        _c$html4 = c.html,
        html = _c$html4 === void 0 ? "Enter a value" : _c$html4,
        _c$icon5 = c.icon,
        icon = _c$icon5 === void 0 ? "question" : _c$icon5,
        _c$buttonName = c.buttonName,
        buttonName = _c$buttonName === void 0 ? "OK" : _c$buttonName,
        _c$input = c.input,
        input = _c$input === void 0 ? 'text' : _c$input,
        _c$inputValue = c.inputValue,
        inputValue = _c$inputValue === void 0 ? '' : _c$inputValue;

    var _Swal$fire$then4 = Swal.fire({
      html: html,
      confirmButtonText: buttonName,
      icon: icon,
      input: input,
      inputValue: inputValue,
      showCancelButton: cancelButton
    }).then(function (result) {
      if (result) {
        if (result.dismiss !== Swal.DismissReason.cancel) {
          if (result.value !== "") {
            if (c.callback !== undefined) {
              c.callback(result);
            }
          } else {
            c.callback(false);
          }
        } else {
          c.callback(false);
        }
      }
    }),
        result = _Swal$fire$then4.value;
  }

  function custom(_x) {
    return _custom.apply(this, arguments);
  }

  function _custom() {
    _custom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(c) {
      var _c$icon6, icon, _c$msg2, msg, _c$title2, title, _c$showConfirmButton, showConfirmButton, _c$prefConfirm, prefConfirm, _yield$Swal$fire, result;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _c$icon6 = c.icon, icon = _c$icon6 === void 0 ? "" : _c$icon6, _c$msg2 = c.msg, msg = _c$msg2 === void 0 ? "" : _c$msg2, _c$title2 = c.title, title = _c$title2 === void 0 ? "" : _c$title2, _c$showConfirmButton = c.showConfirmButton, showConfirmButton = _c$showConfirmButton === void 0 ? true : _c$showConfirmButton, _c$prefConfirm = c.prefConfirm, prefConfirm = _c$prefConfirm === void 0 ? "" : _c$prefConfirm;
              _context.next = 3;
              return Swal.fire({
                icon: icon,
                title: title,
                html: msg,
                backdrop: false,
                focusConfirm: false,
                showCancelButton: true,
                showConfirmButton: showConfirmButton,
                willOpen: function willOpen() {
                  if (c.willOpen !== undefined) {
                    c.willOpen();
                  }
                },
                preConfirm: function preConfirm() {
                  return prefConfirm;
                },
                didOpen: function didOpen() {
                  if (c.didOpen !== undefined) {
                    c.didOpen();
                  }
                }
              });

            case 3:
              _yield$Swal$fire = _context.sent;
              result = _yield$Swal$fire.value;

              if (result) {
                if (result.dismiss !== Swal.DismissReason.cancel) {
                  if (result.value !== "") {
                    if (c.callback !== undefined) {
                      c.callback(result);
                    }
                  } else {
                    c.callback(false);
                  }
                } else {
                  c.callback(false);
                }
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _custom.apply(this, arguments);
  }

  return {
    confirm: confirm,
    alert: alert,
    promptConfirm: promptConfirm,
    prompt: prompt,
    toast: toast,
    custom: custom
  };
}

function post(path, params) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
  var form = document.createElement('form');
  form.method = method;
  form.action = path;

  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      var hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = params[key];
      form.appendChild(hiddenField);
    }
  }

  var csrfField = document.createElement('input');
  csrfField.type = 'hidden';
  csrfField.name = 'csrf_token';
  csrfField.value = document.querySelector('meta[name="csrf-token"]').content;
  form.appendChild(csrfField);
  document.body.appendChild(form);
  form.submit();
}

var makePromiseRequest = function makePromiseRequest(url, method, data) {
  var ajax = new XMLHttpRequest();
  return new Promise(function (resolve, reject) {
    ajax.onreadystatechange = function () {
      // Only run if the request is complete
      if (ajax.readyState !== 4) return; // Process the response

      if (ajax.status >= 200 && ajax.status < 300) {
        var resp = ajax.response;
        var json = JSON.parse(resp);
        document.getElementById("slider_id").value = json.slider_id;
        refreshSliderImages();
        resolve(ajax);
      } else {
        reject({
          status: ajax.status,
          statusText: ajax.statusText
        });
      }
    };

    ajax.open(method || 'POST', url, true);
    ajax.send(data);
  });
};

function fadeIn(elem, ms) {
  if (!elem) return;
  elem.style.opacity = 0;
  elem.style.filter = "alpha(opacity=0)";
  elem.style.display = "inline-block";
  elem.style.visibility = "visible";

  if (ms) {
    var opacity = 0;
    var timer = setInterval(function () {
      opacity += 50 / ms;

      if (opacity >= 1) {
        clearInterval(timer);
        opacity = 1;
      }

      elem.style.opacity = opacity;
      elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
    }, 50);
  } else {
    elem.style.opacity = 1;
    elem.style.filter = "alpha(opacity=1)";
  }
}

function fadeOut(elem, ms) {
  if (!elem) return;

  if (ms) {
    var opacity = 1;
    var timer = setInterval(function () {
      opacity -= 50 / ms;

      if (opacity <= 0) {
        clearInterval(timer);
        opacity = 0;
        elem.style.display = "none";
        elem.style.visibility = "hidden";
      }

      elem.style.opacity = opacity;
      elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
    }, 50);
  } else {
    elem.style.opacity = 0;
    elem.style.filter = "alpha(opacity=0)";
    elem.style.display = "none";
    elem.style.visibility = "hidden";
  }
}